import { useAuth } from '@lastbrand/fe-common/universal-auth'
import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

import Breadcrumbs from '@src/quince-components/src/atoms/breadCrumb/BreadCrumb'
import { Icon } from '@src/quince-components/src/atoms/icon'
import Directory from '@src/quince-site-common/src/domains/Directory'
import { SearchType } from '@src/quince-site-common/src/services/orderAggregatorService/orderAggregatorService.types'
import backArrow from '@src/quince-site-integrated/src/assets/Arrow.svg'

import styles from '../find-my-order.module.scss'

interface Props {
  setNoMatchesFound: (noMatchesFound: boolean) => void
  setSearchError: (searchError: boolean) => void
  step: number
  setStep: (step: number) => void
  searchType: SearchType
}
const MY_PROFILE_ROUTE = '/account/my-profile'
const MY_ORDERS_RETURNS_ROUTE = '/account/my-orders-returns'
const FIND_MY_ORDER_ROUTE = '/find-my-order'
export default function Header(props: Props) {
  const { step, setStep, searchType, setNoMatchesFound, setSearchError } = props
  const { isLoggedIn } = useAuth()
  const { t } = useTranslation('common')

  const searchTypeText = useMemo(() => {
    switch (searchType) {
      case SearchType.CARD_LAST_FOUR_ZIP:
        return t('payment_information')
      case SearchType.EMAIL:
        return t('email_v1')
      default:
        return ''
    }
  }, [searchType, t])

  if (step === 0) {
    return (
      <>
        {isLoggedIn && (
          <Breadcrumbs
            directory={
              new Directory({
                paths: [
                  { displayName: t('account'), route: MY_PROFILE_ROUTE },
                  { displayName: t('my_orders'), route: MY_ORDERS_RETURNS_ROUTE },
                  { displayName: t('find_your_order'), route: FIND_MY_ORDER_ROUTE },
                ],
              })
            }
          />
        )}
        <h1 className={styles.findMyOrderHeader}>{isLoggedIn ? t('find_your_order') : t('find_your_account')} </h1>
      </>
    )
  }

  return (
    <div>
      <Icon
        iconSvg={backArrow}
        className={styles.backArrowIcon}
        onClick={() => {
          setStep(0)
          setNoMatchesFound(false)
          setSearchError(false)
        }}
      />
      <div className={styles.searchOrderSubText}>
        {isLoggedIn ? t('search_order_by') : t('search_account_by')} {searchTypeText}
      </div>
    </div>
  )
}
